import { Button, ButtonBaseProps } from '@shared/components/Button';
import { i18n } from '@shared/util/i18n';
import { useMenuContext } from './MenuContext';

type MenuCloseButtonProps = Pick<ButtonBaseProps, 'onClick' | 'testID' | 'className'>;

/**
 * Menu.CloseButton
 *
 * Ghost, icon-only X that closes the menu. Render it in a `Menu.TitleBar`'s
 * `endContent`, or anywhere else inside `Menu.Content`. Pass `onClick` to
 * override the default close.
 */

export function MenuCloseButton({
  onClick,
  testID = 'menu-close-button',
  className,
}: MenuCloseButtonProps) {
  const { close } = useMenuContext();
  return (
    <Button
      icon="exit-heavy"
      iconGridSize={3}
      iconOnly
      variant="ghost"
      size="medium"
      label={i18n('common.close')}
      onClick={onClick ?? close}
      testID={testID}
      className={className}
    />
  );
}
